module.exports = __webpack_public_path__ + "media/images/story/top/point_4-196c9d4343c543673f07e61d29ac0890.svg";